export function preventEvent(e: Pick<Event, 'preventDefault'>) {
  e.preventDefault();
}
